import type { SiteControllerSettingNeppanFormModel } from "@/components/features/settings/site-controller/model/neppan/type";
import type { SiteControllerSettingNeppanFormModelMethodsType } from "@/components/features/settings/site-controller/model/neppan/use-case/use-create-model/methods";

import { SettingsSiteControllerNeppanPassword } from "./password";
import { SettingsSiteControllerNeppanSetUpRoomPriceByChillnn } from "./set-up-room-price-by-chillnn";

type Props = {
	neppanViewModel: SiteControllerSettingNeppanFormModel["ViewModel"]; //
	siteControllerSettingNeppanFormModelMethodsType: SiteControllerSettingNeppanFormModelMethodsType;
};

export const SettingsSiteControllerNeppanMainSection = ({
	neppanViewModel,
	siteControllerSettingNeppanFormModelMethodsType,
}: Props) => {
	return (
		<>
			<SettingsSiteControllerNeppanPassword
				hotelID={neppanViewModel.hotelID}
				password={neppanViewModel.password}
				onSetPassword={
					siteControllerSettingNeppanFormModelMethodsType.siteControllerSettingNeppanFormModelMethods
						.onSetPassword
				}
			/>
			<SettingsSiteControllerNeppanSetUpRoomPriceByChillnn
				setUpRoomPriceByChillnn={neppanViewModel.setUpRoomPriceByChillnn}
				onSetSetUpRoomPriceByChillnn={
					siteControllerSettingNeppanFormModelMethodsType.siteControllerSettingNeppanFormModelMethods
						.onSetSetUpRoomPriceByChillnn
				}
			/>
		</>
	);
};

SettingsSiteControllerNeppanMainSection.displayName = "SettingsSiteControllerNeppanMainSection";
